var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVisibilitySensor = _interopRequireDefault(require("react-visibility-sensor"));

var _Basic = require("../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Web/VisibilitySensor/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var VisibilitySensor = function (_React$Component) {
  (0, _inherits2.default)(VisibilitySensor, _React$Component);

  var _super = _createSuper(VisibilitySensor);

  function VisibilitySensor() {
    var _this;

    (0, _classCallCheck2.default)(this, VisibilitySensor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderChildren = function (childrenDisplayMode, children, isVisible, visibilityRect) {
      _this.isVisible = isVisible;

      switch (childrenDisplayMode) {
        case 'equal':
          return isVisible && children;

        case 'different':
          return !isVisible && !_this.checkVisibiltyArea(visibilityRect) && children;

        default:
          return children;
      }
    };

    _this.checkVisibiltyArea = function (visibilityRect) {
      var visibilityArea = _this.props.visibilityArea;
      if (!visibilityRect) return false;

      switch (visibilityArea) {
        case 'top':
          return visibilityRect.top;

        default:
          return visibilityRect.top && visibilityRect.bottom && visibilityRect.left && visibilityRect.right;
      }
    };

    return _this;
  }

  (0, _createClass2.default)(VisibilitySensor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          childrenDisplayMode = _this$props.childrenDisplayMode,
          children = _this$props.children,
          viewStyle = _this$props.viewStyle,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["childrenDisplayMode", "children", "viewStyle"]);
      return _react.default.createElement(_reactVisibilitySensor.default, (0, _extends2.default)({}, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 13
        }
      }), function (_ref) {
        var isVisible = _ref.isVisible,
            visibilityRect = _ref.visibilityRect;
        return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
          minWidth: 1,
          minHeight: 1
        }, viewStyle, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 21
          }
        }), _this2.renderChildren(childrenDisplayMode, children, isVisible, visibilityRect));
      });
    }
  }]);
  return VisibilitySensor;
}(_react.default.Component);

VisibilitySensor.propTypes = {
  viewStyle: _propTypes.default.object,
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
  childrenDisplayMode: _propTypes.default.string,
  visibilityArea: _propTypes.default.string
};
var _default = VisibilitySensor;
exports.default = _default;